import { ReactNode } from 'react';

import { StepLabel, stepLabelClasses, styled, SxProps } from '@mui/material';

import { primaryColors, vestaAltGradient, vestaGradient } from '~components/theme/styles/colors';

import { StepperVariant } from './dialogStepper';

type GradientStepIcon = {
  variant?: StepperVariant;
  sx?: SxProps;
  children?: ReactNode;
  size?: string;
  active?: boolean;
};

const GradientIcon = styled('div')<{ size: string }>(({ size }) => ({
  background: primaryColors[900],
  borderRadius: '50%',
  width: size,
  height: size,
  margin: '0 4px',
}));

export const GradientStepLabel: React.FC<GradientStepIcon> = ({
  children,
  sx,
  variant = 'primary',
  size = '16px',
  active = true,
}) => {
  const createIcon = () => <GradientIcon size={size} />;

  return (
    <StepLabel
      sx={{
        [`.${stepLabelClasses.iconContainer}`]: {
          paddingRight: 0,
        },
        [`.${stepLabelClasses.completed}.${stepLabelClasses.iconContainer} div`]: {
          background: active ? (variant === 'primary' ? vestaGradient : vestaAltGradient) : undefined,
        },
        ...sx,
      }}
      StepIconComponent={createIcon}
    >
      {children}
    </StepLabel>
  );
};

export const SmallGradientStepLabel = ({ active = true }) => (
  <GradientStepLabel
    active={active}
    sx={{
      padding: 0,
      alignItems: 'start',
      marginLeft: '4px',
    }}
    size="8px"
  />
);
